import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/contexts/AppContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function Kpi({ label, value, icon: Icon, color = "#1E4631", sub, testid }) {
  return (
    <div className="bg-white rounded-xl border border-[#E5EBE7] p-4" data-testid={testid}>
      <div className="flex items-center gap-2 text-[11px] text-[#5C6B61] uppercase tracking-wider">
        {Icon && <Icon className="w-4 h-4" style={{ color }} />}{label}
      </div>
      <div className="mt-2 text-2xl font-[Outfit] font-bold" style={{ color }}>{value}</div>
      {sub && <div className="text-xs text-[#5C6B61] mt-1">{sub}</div>}
    </div>
  );
}

export function Section({ title, icon: Icon, action, children, testid }) {
  return (
    <div className="bg-white rounded-2xl border border-[#E5EBE7] p-5" data-testid={testid}>
      <div className="flex items-center justify-between mb-4 gap-3 flex-wrap">
        <h2 className="font-[Outfit] font-semibold text-lg inline-flex items-center gap-2 text-[#1E4631]">
          {Icon && <Icon className="w-5 h-5 text-[#D96C4A]" />}{title}
        </h2>
        {action}
      </div>
      {children}
    </div>
  );
}

export function Empty({ children }) {
  return <div className="py-8 text-center text-sm text-[#5C6B61] italic">{children}</div>;
}

export function Pill({ children, color = "#1E4631", testid }) {
  return (
    <span className="inline-block px-2 py-0.5 rounded-full text-[11px] font-semibold" style={{ background: `${color}18`, color }} data-testid={testid}>
      {children}
    </span>
  );
}

export function PageTitle({ icon: Icon, title, subtitle, action }) {
  return (
    <div className="flex items-start justify-between gap-4 flex-wrap">
      <div>
        <h1 className="text-3xl font-[Outfit] font-bold inline-flex items-center gap-3">
          {Icon && <span className="w-11 h-11 rounded-xl bg-[#1E4631] grid place-items-center"><Icon className="w-6 h-6 text-white" /></span>}
          {title}
        </h1>
        {subtitle && <p className="text-sm text-[#5C6B61] mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function usePatients(category) {
  const [patients, setPatients] = useState([]);
  useEffect(() => {
    const params = { page_size: 2000 };
    if (category) params.category = category;
    axios.get(`${API}/patients`, { params }).then((r) => setPatients(r.data.items || [])).catch(() => setPatients([]));
  }, [category]);
  return patients;
}

export function PatientSelect({ patients, value, onChange, testid, placeholder = "Sélectionner un patient…" }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testid}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent className="max-h-72">
        {patients.map((p) => (
          <SelectItem key={p.id} value={p.id}>{p.name} · {p.age} ans · {p.phone}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" }) : "—");
export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "—");

export async function downloadFile(url, fallbackName) {
  const r = await axios.get(url, { responseType: "blob" });
  const cd = r.headers["content-disposition"] || "";
  const m = cd.match(/filename="?([^"]+)"?/);
  const a = document.createElement("a");
  a.href = URL.createObjectURL(r.data);
  a.download = (m && m[1]) || fallbackName;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 2000);
}
